import axios from 'axios';
import AppSettings from '../../../../core/AppSettings';

export const getSimilarItemsData = (placeholderParam)=>{
    const SimilarItemsUrl = "/wcs/resources/store/" + AppSettings.storeId + "/productSearch/similarItems/" + placeholderParam;
    return axios.get(SimilarItemsUrl).then(response=>response.data).catch(error=>console.log("error",error));
};

